import { render, staticRenderFns } from "./RuleEdit.vue?vue&type=template&id=2bdb91c6&scoped=true&"
import script from "./RuleEdit.vue?vue&type=script&lang=js&"
export * from "./RuleEdit.vue?vue&type=script&lang=js&"
import style0 from "./RuleEdit.vue?vue&type=style&index=0&id=2bdb91c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdb91c6",
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QFooter from 'quasar/src/components/footer/QFooter.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBtn,QTooltip,QCard,QCardSection,QItem,QInput,QAvatar,QDialog,QCardActions,QFooter});qInstall(component, 'directives', {ClosePopup});
